export function getCaseInsensitivePropertyKey(obj: Record<string, unknown> | undefined, propertyName: string): string | undefined {
	if (!obj) return undefined;

	if (Object.prototype.hasOwnProperty.call(obj, propertyName)) {
		return propertyName;
	}

	const lowerPropertyName = propertyName.toLowerCase();
	return Object.keys(obj).find((key) => key.toLowerCase() === lowerPropertyName);
}

export function getCaseInsensitivePropertyValue<T = unknown>(obj: Record<string, T> | undefined, propertyName: string): T | undefined {
	const key = getCaseInsensitivePropertyKey(obj, propertyName);
	return key ? obj?.[key] : undefined;
}
